import { TextField } from "@mui/material";
import React from "react";

export default function SearchAutoSubmit({ onchange, placeholder, noStyle }) {
  return (
    <div className={noStyle ? "" : "relative w-full"}>
      <div className={noStyle ? "" : "mx-3 mt-3 flex items-center"}>
        <TextField
          className="w-full min-w-[300px] rounded-lg text-sm placeholder:text-center"
          placeholder={placeholder}
          size="small"
          name="search"
          //value={value}
          InputLabelProps={{ shrink: true }}
          label="Search"
          onChange={(event) => onchange(event.target.value)}
        />
      </div>
    </div>
  );
}
